import styled from "@emotion/styled";
import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close"

const Modals = styled(Box)({
    background: 'rgba(168, 200, 175, 0.5)',
    color: '#fff',
    position: 'fixed',
    top: '0',
    left: '0',
    height: '100vh',
    width: '100vw',
    transition: 'all .5s',
    zIndex: '1',
    display: 'flex',
    alignItems: 'center',
});

const ModalContent = styled(Box)({
    background: '#ffff',
    height: '70vh',
    width: '50%',
    margin: 'auto auto auto 30vw',
    color: 'black',
    borderRadius: '1rem',
    zIndex: '1',
    overflowX: 'auto',
});

const ButtonClosed = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    color: '#ffff',
    position: 'fixed',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

export default function Modal(props){

    return(
        <React.Fragment>
            {props.activeModal &&
                <Modals>
                    <ModalContent>
                        <Box display={'flex'} justifyContent={'end'}>
                            <ButtonClosed onClick={props.handleModal}><CloseIcon></CloseIcon></ButtonClosed>
                        </Box>
                        {props?.children}
                    </ModalContent>
                </Modals>
            }
        </React.Fragment>
    )
}